<template lang="pug">
    div
        .text-xs(:class="ended ? 'text-red-500' : 'text-gray-600'" :title="currentLabel") {{ shortLabel }}
        button.mt-1.text-xs.underline.cursor-pointer(type="button" @click="open") {{ hasPromotion ? 'изменить' : 'выбрать' }}
        modal(:name="modalName" height="auto" :width="420" :adaptive="true" :scrollable="true" classes="form-modal")
            .p-4.bg-gray-100
                .text-sm.font-medium.mb-3 Акция получателя
                select.w-full.h-10.pl-3.pr-3.border.rounded.border-slate-300.bg-white.text-xs(v-model="promotionId")
                    option(value="") выберите акцию
                    optgroup(v-if="sharedPromotions.length" label="Общие")
                        option(
                            v-for="item in sharedPromotions"
                            :key="item._id"
                            :value="item._id"
                            :style="item.active ? null : { color: '#ef4444' }"
                        ) {{ promotionLabel(item) }}
                    optgroup(v-if="stationPromotions.length" label="Станция")
                        option(
                            v-for="item in stationPromotions"
                            :key="item._id"
                            :value="item._id"
                            :style="item.active ? null : { color: '#ef4444' }"
                        ) {{ promotionLabel(item) }}
                .flex.gap-3.mt-4
                    regular-button.w-200(:value="BUTTONS_VALUES.save" :loading="saving" @click="onSave")
                    regular-button.w-200(:value="BUTTONS_VALUES.cancel" color="gray" @click="close")
</template>

<script>
import RegularButton from '@/components/common/buttons/regular-button';
import { BUTTONS_VALUES } from '@/configs/names';
import { RecipientsNameSpace, RecipientsActionTypes } from '@/store/recipients/types';
import { PromotionsNameSpace, PromotionsActionTypes } from '@/store/promotions/types';
import { _openModal_, _closeModal_ } from '@/mixins/modals';
import { notifyError } from '@/helpers/notifications';

export default {
    name: "RecipientPromotion",
    mixins: [_openModal_, _closeModal_],
    components: {
        'regular-button': RegularButton,
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            promotionId: '',
            promotions: [],
            saving: false,
        }
    },
    computed: {
        BUTTONS_VALUES() {
            return BUTTONS_VALUES
        },
        modalName() {
            return `recipient-promotion-${this.item._id}`
        },
        promotion() {
            const value = this.item.promotion
            if (!value || typeof value !== 'object') {
                return null
            }
            return value
        },
        hasPromotion() {
            return Boolean(this.promotion && this.promotion.name)
        },
        ended() {
            return Boolean(this.promotion && this.promotion.active === false)
        },
        currentLabel() {
            if (!this.hasPromotion) {
                return 'акция не выбрана'
            }
            const shared = Number(this.promotion.group) === 0 ? ' (общая)' : ''
            const ended = this.ended ? ' — Закончилась' : ''
            return `${this.promotion.name}${shared}${ended}`
        },
        shortLabel() {
            if (!this.hasPromotion) {
                return this.currentLabel
            }
            const name = String(this.promotion.name || '')
            const shared = Number(this.promotion.group) === 0 ? ' (общая)' : ''
            const ended = this.ended ? ' — Закончилась' : ''
            const visible = name.length <= 40 ? name : `${name.slice(0, 40).trimEnd()}…`
            return `${visible}${shared}${ended}`
        },
        sharedPromotions() {
            return this.promotions.filter((item) => Number(item.group) === 0)
        },
        stationPromotions() {
            return this.promotions.filter((item) => Number(item.group) !== 0)
        },
    },
    methods: {
        promotionLabel(item) {
            return item.active ? item.name : `${item.name} — Закончилась`
        },
        async open() {
            this.promotionId = this.promotion && this.promotion._id ? this.promotion._id : ''
            await this.loadPromotions()
            this._openModal_({ name: this.modalName })
        },
        close() {
            this._closeModal_({ name: this.modalName })
        },
        async loadPromotions() {
            const rows = []
            let page = 0
            let total = 0
            do {
                const body = await this.$store.dispatch(`${PromotionsNameSpace}/${PromotionsActionTypes.GetPromotions}`, {
                    params: { group: this.item.group, per_page: 100, page },
                })
                const chunk = (body && body.data && body.data.data) || []
                total = (body && body.data && body.data.total) || 0
                rows.push(...chunk)
                page += 1
                if (!chunk.length) {
                    break
                }
            } while (rows.length < total && page < 20)
            this.promotions = rows.slice().sort((left, right) => {
                if (left.active !== right.active) {
                    return left.active ? -1 : 1
                }
                return String(left.name).localeCompare(String(right.name), 'ru')
            })
        },
        async onSave() {
            if (this.saving) {
                return
            }
            if (!this.promotionId) {
                notifyError({ title: 'Укажите акцию' })
                return
            }
            this.saving = true
            try {
                await this.$store.dispatch(`${RecipientsNameSpace}/${RecipientsActionTypes.SetRecipientPromotion}`, {
                    id: this.item._id,
                    promotion: this.promotionId,
                })
                this.close()
            } catch (error) {
                return error
            } finally {
                this.saving = false
            }
        },
    },
}
</script>
